import { render } from "./Lookbook.vue?vue&type=template&id=5f4e7c25&scoped=true"
import script from "./Lookbook.vue?vue&type=script&lang=js"
export * from "./Lookbook.vue?vue&type=script&lang=js"

import "./Lookbook.vue?vue&type=style&index=0&id=5f4e7c25&lang=scss&scoped=true"
import "./Lookbook.vue?vue&type=style&index=1&id=5f4e7c25&lang=scss"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4e7c25"]])

export default __exports__